// Normalize entered zip or postal code value in preparation to put the value in the store.
// substr(0, 11) takes only the first 10 characters of the value
// replace(/\D/g, '') removes any characters which are not numeric digits
const normalizeZipPostal = value => (value ? value.substr(0, 10).replace(/\D/g, '') : '');

export default normalizeZipPostal;
